









import Vue from 'vue'
import { share } from "@/utils/hybird";
export default Vue.extend({
    created(){
        share();
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
        window.history.pushState({}, 'title', '#')
        }
    }
})
